import React from 'react'

import { InView } from 'react-intersection-observer';

import {
  baseDomain,
  DefaultCdnBaseUrl,
  DefaultAspectRatio,
} from '../../utils'

class ScrollAnimatedInlineVideoContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isVideoLoaded: false,
      videoIsVisible: false,
      videoBlobSrc: undefined
    }
    this.videoElementRef = React.createRef();

    this.playVideo = this.playVideo.bind(this);
  }

  // handleDownloadProgress = () => {
  //   if (this.videoElementRef.current.buffered.length > 0 && !this.state.isVideoLoaded) {
  //     const bufferingPercentage = this.videoElementRef.current.buffered.end(0) / this.videoElementRef.current.duration
  //     const loadedPercentage = bufferingPercentage > 0.8 ? 1 : bufferingPercentage
  //     console.log(`DOWNLOAD PROGRESS: ${this.videoElementRef.current.buffered.end(0)} / ${this.videoElementRef.current.duration},\tLOADED ${loadedPercentage}`)
  //     this.props.onDownloadProgress(loadedPercentage)
  //     if (loadedPercentage === 1) {
  //       this.handleCanPlayThrough()
  //       return true
  //     }
  //     return false
  //   }
  // }

  componentDidMount() {
    if (!!(this.videoElementRef) && !!(this.videoElementRef.current)) {
      this.videoElementRef.current.onerror = () => {
        console.error(
          `Error Loading Video: ${this.videoElementRef.current.error.code}; details: ${this.videoElementRef.current.error.message}`
        );
      }
    }
  }

  componentWillUpdate(prevProps) {
    if (!!(this.videoElementRef) && !!(this.videoElementRef.current) && this.state.isVideoLoaded && this.videoElementRef.current.duration > 0) {
      const nextCurrentTime = Math.min(this.videoElementRef.current.duration, this.videoElementRef.current.duration * this.props.currentProgressPct)
      if (nextCurrentTime !== this.videoElementRef.current.currentTime) {
        this.videoElementRef.current.currentTime = nextCurrentTime
      }
    }
  }

  playVideo() {
    if (!!(this.videoElementRef) && !!(this.videoElementRef.current)) {
      this.videoElementRef.current.playbackRate = this.props.playbackRate || 0.75
      this.videoElementRef.current.play()
    }
  }

  pauseVideo() {
    if (!!(this.videoElementRef) && !!(this.videoElementRef.current)) {
      this.videoElementRef.current.playbackRate = this.props.playbackRate || 0.75
      this.videoElementRef.current.pause()
    }
  }

//   preloadVideo() {
//     const {videoPath, baseContentUrl, isIOSDevice, isAndroidDevice} = this.props

//     var req = new XMLHttpRequest();
//     req.addEventListener("loadstart", () => {});
//     req.addEventListener("load", async event => {
//       console.log(`FINISHED LOADING VIDEO: ${req.status}`)
//        // Onload is triggered even on 404
//        // so we need to check the status code
//        if (req.status >= 200 && req.status <= 206) {
//         console.log(`LOADING VIDEO SUCCESS: ${req.response}`)
//           var videoBlob = req.response;
//           var videoBlob = new Blob([req.response], { type: 'video/mp4' });
//           var vid = URL.createObjectURL(videoBlob); // IE10+
//           console.log(vid)

//           this.setState({videoBlobSrc: vid})

//           await this.videoElementRef.current.pause()
//           this.videoElementRef.current.currentTime = 0

//           if (this.props.registerManualStartEvent) {
//             this.props.registerManualStartEvent(async () => {
//               await this.videoElementRef.current.play()
//               await this.videoElementRef.current.pause()
//             })
//           }
//           this.handleCanPlayThrough()
//        }
//     });
//     req.addEventListener("progress", (progressEvent) => {
//       console.log(`VIDEO LOADING PROGRESS: lengthComputable = ${progressEvent.lengthComputable}, ${progressEvent.loaded} / ${progressEvent.total} bytes loaded.`)
//       if (progressEvent.lengthComputable) {
//         const loadedPercentage = progressEvent.loaded / progressEvent.total
//         this.props.onDownloadProgress(loadedPercentage)
//       }
//     });
//     req.addEventListener("error", (e) => {
//       console.log(`ERROR LOADING VIDEO: ${e.type}`)
//     });
//     req.responseType = 'blob';

//     const fullVideoPath = baseContentUrl + videoPath
//     req.open('GET', fullVideoPath, true);

//     req.send();
//   }

// handleCanPlayThrough = () => {
//     console.log(`HANDLE CANPLAYTHROUGH`)
//     const {isVideoLoaded} = this.state
//     const {onVideoLoad} = this.props
//     if (!isVideoLoaded) {
//       this.setState({isVideoLoaded: true})
//       if (!!onVideoLoad) {
//         onVideoLoad()
//       }
//     }
//   }

  onProgress = async () => {
    console.log(`ENTER DOWNLOAD PROGRESS`)
    if (this.videoElementRef.current.buffered.length > 0 && !this.state.isVideoLoaded) {
      const bufferingPercentage = this.videoElementRef.current.buffered.end(0) / this.videoElementRef.current.duration
      const loadedPercentage = bufferingPercentage > 0.8 ? 1 : bufferingPercentage
      console.log(`DOWNLOAD PROGRESS: ${this.videoElementRef.current.buffered.end(0)} / ${this.videoElementRef.current.duration},\tLOADED ${loadedPercentage}`)
      this.props.onDownloadProgress(loadedPercentage)
      if (loadedPercentage === 1) {
        await this.onCanPlayThrough()
        return true
      }
      return false
    }
  }

  onCanPlayThrough = async () => {

    console.log(`HANDLE CANPLAYTHROUGH`)
    const {isVideoLoaded} = this.state
    const {onVideoLoad} = this.props
    if (!isVideoLoaded) {
      this.setState({isVideoLoaded: true})

      await this.videoElementRef.current.pause()
      this.videoElementRef.current.currentTime = 0

      if (this.props.registerManualStartEvent) {
        this.props.registerManualStartEvent(async () => {
          await this.videoElementRef.current.play()
          await this.videoElementRef.current.pause()
        })
      }

      if (!!onVideoLoad) {
        onVideoLoad()
      }
    }
  }

  render() {
    const {
      videoPath,
      videoPosterPath,
      widthPixels,
      aspectRatio,
      isVideoVisible,
      baseContentUrl,
      playbackRate,
      disableAutoPlay,
      onVideoLoad,
      onVideoPlay,
      canManuallyStartVideo,
      hideLoadingAnimation,
      hideLoadedAnimation,
      registerManualStartEvent,
      onDownloadProgress,
      lazyLoadVideo,
      isIOSDevice,
      isAndroidDevice
    } = this.props

    const {
      isVideoLoaded,
      videoIsVisible,
      videoBlobSrc
    } = this.state

    const isVideoOnScreen = isVideoLoaded && isVideoVisible

    return (
      <InView triggerOnce threshold={0.01} fallbackInView={true} as="div" onChange={(inView, entry) => {
        if (inView) {
          this.setState({videoIsVisible: true})
        }
      }}>
        <div 
          
          style={{width: widthPixels, height: widthPixels * (aspectRatio || DefaultAspectRatio)}}
        >
          <video
            width={"100%"}
            height={"100%"}
            alt="phone-flip-hero"
            title="phone-flip-hero"
            muted
            playsInline
            autoPlay={isIOSDevice}
            onPlay={() => {
              this.pauseVideo()
            }}
            ref={this.videoElementRef}
            onLoadedMetadata={() => console.log("LOADED METADATA")}
            onProgress={!isVideoLoaded ? () => this.onProgress() : undefined}
            onCanPlayThrough={!isVideoLoaded ? () => this.onCanPlayThrough() : undefined}
            onError={e => console.log(`ERROR LOADING VIDEO: ${e}`)}
          >
            <source type="video/mp4" src={baseContentUrl + videoPath}>
            </source>
          </video>
          )}
        </div>
      </InView>
    )
  }
}

export default ScrollAnimatedInlineVideoContainer;